import updateSelectFromArray from './update-select-from-array';
import numberFormat from '../../../../../used-vue/api/NumberFormat';

export default function(mileageArray, element) {
    updateSelectFromArray(mileageArray, element, (miles) => {
        return numberFormat(miles, 0) + ((miles == 1) ? ' mile' : ' miles');
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/new-car-pages/modules/details/finance/finance-types/update-mileage-select-from-array.js